module.exports = __webpack_public_path__ + "static/media/5.44e8ba5b.jpg";